import React, { useState, ButtonHTMLAttributes, useEffect } from 'react';
import Drawer from '@material-ui/core/Drawer';
import { IoIosCloseCircleOutline } from 'react-icons/io';

import { DrawerContainer, CloseButton } from './styles';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

interface DrawerProps {
  buttonTitle: string;
  buttonDescription?: string;
  img_drawer?: string;
  openButton: React.ComponentType<ButtonProps>;
  isClosed?: boolean;
}

const DrawerMenu: React.FC<DrawerProps> = ({
  buttonTitle,
  buttonDescription,
  img_drawer,
  openButton: OpenButton,
  children,
  isClosed,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isClosed) setIsOpen(!isClosed);
  }, [isClosed]);

  const toggleDrawer = (value: boolean) => () => {
    setIsOpen(value);
  };

  return (
    <>
      <OpenButton onClick={toggleDrawer(true)}>
        {img_drawer && <img src={img_drawer} alt={buttonTitle} />}
        <div>
          <p>{buttonTitle}</p>
          {buttonDescription && <span>{buttonDescription}</span>}
        </div>
      </OpenButton>

      <Drawer anchor="right" open={isOpen} onClose={toggleDrawer(false)}>
        <CloseButton onClick={toggleDrawer(false)} type="button">
          <IoIosCloseCircleOutline size={24} />
        </CloseButton>

        <DrawerContainer role="presentation">{children}</DrawerContainer>
      </Drawer>
    </>
  );
};

export default DrawerMenu;
